import { createIcon } from '@chakra-ui/icons';

export const PointerOutline = createIcon({
  displayName: 'PoiinterOutline',
  viewBox: '0 0 24 24',
  path: [
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.77552 14.6289L9.61601 14.2169L9.20399 14.0573L1.20105 10.9592L21.2702 2.56265L12.8737 22.6318L9.77552 14.6289Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>,
  ],
});
